export type FileStatus = "pending" | "processing" | "done" | "error";

export interface FileProgress {
  name: string;
  status: FileStatus;
  errorMessage?: string;
}

interface Props {
  items: FileProgress[];
}

const STATUS_LABEL: Record<FileStatus, string> = {
  pending: "Warten",
  processing: "Verarbeite…",
  done: "✓ Fertig",
  error: "Fehler",
};

const STATUS_COLOR: Record<FileStatus, string> = {
  pending: "text-kampmeyer-neutral-500",
  processing: "text-kampmeyer-primary",
  done: "text-green-700",
  error: "text-red-700",
};

export function ProgressView({ items }: Props) {
  const done = items.filter((i) => i.status === "done" || i.status === "error").length;
  const total = items.length;
  const pct = total === 0 ? 0 : Math.round((done / total) * 100);

  return (
    <div className="card">
      <div className="mb-4">
        <h2 className="text-lg font-semibold">Skalierung läuft…</h2>
        <p className="text-sm text-kampmeyer-neutral-500">
          {done} von {total} verarbeitet ({pct}%)
        </p>
        <div className="mt-3 h-2 bg-kampmeyer-neutral-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-kampmeyer-primary transition-all duration-300"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>

      <div className="max-h-72 overflow-y-auto border border-kampmeyer-neutral-100 rounded">
        <table className="w-full text-sm">
          <tbody>
            {items.map((item) => (
              <tr key={item.name} className="border-b border-kampmeyer-neutral-100 last:border-b-0">
                <td className="px-3 py-2 truncate">{item.name}</td>
                <td className={`px-3 py-2 text-right w-32 ${STATUS_COLOR[item.status]}`}>
                  {STATUS_LABEL[item.status]}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
